import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {

  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) {}

  /**
   * Handle logout with proper error handling and user feedback
   */
  async logout(reason?: 'user_initiated' | 'device_conflict' | 'inactivity' | 'token_expired') {
    try {
      // Attempt to logout on server
      await this.authService.logoutWithErrorHandling();
      
      // Clear local tokens
      this.authService.clearTokens();
      
      // Navigate to login
      this.router.navigateByUrl('/login');
      
      // Show appropriate message based on reason
      this.showLogoutMessage(reason);
      
    } catch (error) {
      console.error('Logout error:', error);
      
      // Even if server logout fails, clear local tokens
      this.authService.clearTokens();
      this.router.navigateByUrl('/login');
      
      // Show generic logout message
      this.showLogoutMessage('token_expired');
    }
  }

  /**
   * Handle authentication errors with specific messaging
   */
  handleAuthenticationError(error: any) {
    const errorMessage = error.error?.message || error.message || '';
    
    if (errorMessage.includes('another device')) {
      this.logout('device_conflict');
    } else if (errorMessage.includes('inactivity')) {
      this.logout('inactivity');
    } else {
      this.logout('token_expired');
    }
  }

  /**
   * Show appropriate logout message to user
   */
  private showLogoutMessage(reason?: string) {
    let message = 'You have been logged out.';
    
    switch (reason) {
      case 'device_conflict':
        message = 'You have been logged in from another device. Please login again.';
        break;
      case 'inactivity':
        message = 'Session expired due to inactivity. Please login again.';
        break;
      case 'user_initiated':
        message = 'You have been logged out successfully.';
        break;
      case 'token_expired':
      default:
        message = 'Authentication failed. Please login again.';
        break;
    }
    
    // You can replace this with your preferred notification method
    // For example, using a toast service, alert, or snackbar
    console.warn(message);
    
    // Example with alert (replace with your preferred notification method):
    // alert(message);
    
    // Example with toast service (if you have one):
    // this.toastService.show(message, 'warning');
  }
}
